document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  toggle?.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    menu.hidden = open;
  });
  document.querySelectorAll('[data-quantity]').forEach((group) => {
    const input = group.querySelector('input');
    group.querySelector('[data-minus]')?.addEventListener('click', () => input.stepDown());
    group.querySelector('[data-plus]')?.addEventListener('click', () => input.stepUp());
  });
});
